import { AttachMoney, MoneyOff, MonetizationOn } from "@mui/icons-material"
import ActionMenu, { Action } from '../../../components/ui/materialui/actionMenu';
import { EstadoSolicitudPrepago, TipoFuncionalidad } from '../../../utils/enums';
import { usePermissions } from "../../../components/auth/ProtectedRoute";

interface IProps {
    estado: string,
    actionLiquidar: () => void | null;
    actionRecaudar: () => void | null;
    actionDesrecaudar: () => void | null;
    actionRemesar: () => void | null;
    isDesactivado?: boolean;
}

const AccionesPrepago: React.FC<IProps> = ({ estado, actionLiquidar, actionRecaudar, actionDesrecaudar, actionRemesar, isDesactivado }) => {
const { hasPermission } = usePermissions();
  const puedeEditar = hasPermission(TipoFuncionalidad.Cartera_adm_prepago);
  
    const handleLiquidarClick = () => {
        actionLiquidar();
    }

    const handleRecaudarClick = () => {
        actionRecaudar();
    }

    const handleDesrecaudarClick = () => {
        actionDesrecaudar();
    }

    const actions: Action[] = [];

    if (estado.toLowerCase() === EstadoSolicitudPrepago.GENERADA.toLowerCase() && !isDesactivado) {
        if(puedeEditar) {
        actions.push({ label: "Liquidar Prepago", icon: <AttachMoney fontSize="small" />, onClick: () => handleLiquidarClick() })};
    }
     else if (estado.toLowerCase() === EstadoSolicitudPrepago.LIQUIDADO.toLowerCase() && !isDesactivado) {
        if(puedeEditar) {
        actions.push({ label: "Recaudar Prepago", icon: <AttachMoney fontSize="small" />, onClick: () => handleRecaudarClick() })};
    }
     else if (estado.toLowerCase() === EstadoSolicitudPrepago.RECAUDADA.toLowerCase()) {
        if(puedeEditar) {
        actions.push({ label: "Desrecaudar Prepago", icon: <MoneyOff fontSize="small" />, onClick: () => handleDesrecaudarClick() });
        actions.push({ label: "Remesar Prepago", icon: <MonetizationOn fontSize="small" />, onClick: actionRemesar });
        }
    }


    return (
        <ActionMenu actions={actions} />
    );
}

export default AccionesPrepago;